<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title>
        <h4 class="primary--text">
          {{ $t('tslOrders.title') }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="addOrder"
          depressed
        >
          {{ $t('tslOrders.addOrder') }}
        </v-btn>
      </v-card-title>
      <div class="background px-6">
        <v-tabs v-model="activeTab" :height="60" background-color="background" show-arrows center-active>
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.current') }}</v-tab>
          <v-tab :ripple="false">{{ $t('tslOrders.tabs.archive') }}</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="activeTab" class="py-4">
        <v-tab-item>
          <TSLOrdersTable :show-archived="false" />
        </v-tab-item>
        <v-tab-item>
          <TSLOrdersTable :show-archived="true" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import TSLOrdersTable from './tables/TSLOrdersTable'

export default {
  name: 'TSLOrders',
  components: {
    TSLOrdersTable
  },
  data () {
    return {
      activeTab: 0
    }
  },
  methods: {
    addOrder () {
      this.$router.push({ name: 'AddTSLOrder' })
    }
  }
}
</script>
